import React, { Suspense, lazy } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SituationsSection = lazy(() => import('./components/SituationsSection').then(m => ({
  default: m.SituationsSection
})));
const ProcessSection = lazy(() => import('./components/ProcessSection').then(m => ({
  default: m.ProcessSection
})));
const PortfolioSection = lazy(() => import('./components/PortfolioSection').then(m => ({
  default: m.PortfolioSection
})));
const PillarsSection = lazy(() => import('./components/PillarsSection').then(m => ({
  default: m.PillarsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const WhatsAppButton = lazy(() => import('./components/WhatsAppButton').then(m => ({
  default: m.WhatsAppButton
})));
const SectionSkeleton = () => <div className="w-full h-64 bg-gray-100 animate-pulse" data-id="element-0" />;
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-1">
      <Header data-id="element-2" />
      <HeroSection data-id="element-3" />
      <Suspense fallback={<SectionSkeleton data-id="element-5" />} data-id="element-4">
        <ProblemSection data-id="element-6" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-8" />} data-id="element-7">
        <ProcessSection data-id="element-9" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-11" />} data-id="element-10">
        <PortfolioSection data-id="element-12" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-14" />} data-id="element-13">
        <SituationsSection data-id="element-15" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-17" />} data-id="element-16">
        <PillarsSection data-id="element-18" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-20" />} data-id="element-19">
        <TestimonialsSection data-id="element-21" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-23" />} data-id="element-22">
        <OfferSection data-id="element-24" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-26" />} data-id="element-25">
        <FAQSection data-id="element-27" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-29" />} data-id="element-28">
        <FinalCTASection data-id="element-30" />
      </Suspense>
      <Suspense fallback={<SectionSkeleton data-id="element-32" />} data-id="element-31">
        <Footer data-id="element-33" />
      </Suspense>
      <Suspense fallback={null} data-id="element-34">
        <WhatsAppButton data-id="element-35" />
      </Suspense>
    </div>;
}